import {Button, EmptyState, Icon, Illustration} from '@sollapay/ui/components';
import {ReceiptInHandIllustration} from '@sollapay/ui/illustrations';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface InstructionsEmptyStateProps {
  onCreate?: () => void;
}

export const InstructionsEmptyState: FC<InstructionsEmptyStateProps> = ({onCreate}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <EmptyState
      illustration={
        <Illustration width={166} height={160}>
          <ReceiptInHandIllustration />
        </Illustration>
      }
      title={t('view.instructions.empty.title')}
      subtitle={t('view.instructions.empty.description')}
      action={
        onCreate && (
          <Button variant="primary" size="sm" onClick={onCreate}>
            <Icon name="add" />
            {t('view.instructions.empty.action')}
          </Button>
        )
      }
    />
  );
};
